import { DownloadMimeType } from './file-download.model';

export class ApFileDownloadService {
    /**
     * Download file
     */
    public static initiateBrowserDownload(filename: string, data: Blob, type: DownloadMimeType): void {
        const blob = new Blob([data], { type });

        //Some browsers need a hidden child anchor to be clicked to start the download
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.setAttribute('style', 'display: none');

        anchor.href = URL.createObjectURL(blob);
        anchor.download = filename;

        //Bug in Safari iOS, click + timeout needed
        anchor.click();
        setTimeout(() => {
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(anchor.href);
        }, 1000);
    }
}
